module.exports = __webpack_public_path__ + "static/media/EXCLAMAÇÃO.8d8fb98c.svg";